import { useNavigate } from "react-router-dom";
import { AlertSeverity, useAlerts } from "components/AlertProvider/AlertProvider";
import { orderToasts } from "areas/orders/components/chrome/orderToasts";
import { orderRoutes } from "areas/orders/order-routes";

export function useOpenNewQuote() {
  const navigate = useNavigate();
  const { sendNewAlert } = useAlerts();

  return (odNumber: string) => {
    sendNewAlert(orderToasts.created(odNumber), AlertSeverity.Success);
    navigate(orderRoutes.detail(odNumber).root);
  };
}
